import styled from 'styled-components';

export const UnorderedList = styled.ul`
  padding: 0;
  background-color: transparent;
`;

